export default __webpack_public_path__ + "static/media/Team1.0651ca20.jpg";